import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { UtilsService } from '../../services/utils.service';
import { AoiComponent } from '../aoi/aoi.component';
import { environment } from '../../../environments/environment';
import { ToolsComponent } from '../tools/tools.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewInit {

    @ViewChild('aboutWindow') private readonly aboutWindow: ElementRef<any>;
    @ViewChild('aoi') private aoi: AoiComponent;
    @ViewChild('aoiWindow') private aoiWindow: ElementRef<any>;
    @ViewChild('search') private readonly search: ElementRef<any>;
    @ViewChild('tools') private tools: ToolsComponent;

    constructor(
        private utilsService: UtilsService
    ) { }

    ngAfterViewInit() {
        this.search.nativeElement.excludeTypes = ['map'];
        this.search.nativeElement.filterLayersBeforeAdd = true;
        this.utilsService.aoi = this.aoi;
        this.utilsService.aoiWindow = this.aoiWindow;
        this.aoi.done.subscribe(_ => this.closeAoi());
    }

    get rootUrl() {
        return this.utilsService.getRootUrl();
    }

    get imagePath() {
        let path = '';
        if (this.rootUrl) {
            path = this.rootUrl;
        }
        if (!environment.dotNetCore) {
            path += '/wwwroot';
        }
        return path + '/assets/images';
    }

    get mcMap() {
        return this.utilsService.mcMap;
    }


    get version(): string {
        return environment.version;
    }

    openAbout() {
        this.aboutWindow.nativeElement.open();
    }

    openAoi() {
        this.utilsService.openAoi();
    }

    closeAbout() {
        this.aboutWindow.nativeElement.close();
    }

    closeAoi() {
        this.aoiWindow.nativeElement.close();
    }

    toggleTools() {
        this.tools.visible = !(<any>this.tools).visible;
    }

}
